import Api from '../utilities/api';
import {
  triggerIdA
} from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class GeneralAccess {
    static getMonthlyView = (date, month, clientId) => Api.post('_General_MonthView', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId
        },
        {
          name: 'slctdDate',
          value: date
        },
        {
          name: 'FirstDayOfWeek',
          value: 1
        },
        {
          name: 'MonthAdd',
          value: month
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    });

    static getWeeklyView = (date, weekAt) => Api.post('_General_WeekView', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'slctdDate',
          value: date
        },
        {
          name: 'FirstDayOfWeek',
          value: 1
        },
        {
          name: 'WeekAdd',
          value: 0
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })

    static getMeasureChips = (clientId, selectedDate) => {
      let startDate = new Date(selectedDate);
      startDate = startDate.setDate(startDate.getDate() - 3);
      startDate = new Date(startDate).toLocaleDateString('en-US');

      let endDate = new Date(selectedDate);
      endDate = endDate.setDate(endDate.getDate() + 3);
      endDate = new Date(endDate).toLocaleDateString('en-US');

      return Api.post('_General_MeasureCtgyChips', {
        params: [
          {
            name: 'ScrnId',
            value: TriskeleScreens.dashboard.ScreenId,
          },
          {
            name: 'TrggrId',
            value: triggerIdA
          },
          {
            name: 'BuildfireID',
            value: "D"
          },
          {
            name: 'ClientID',
            value: clientId
          },
          {
            name: 'StartDate',
            value: startDate
          },
          {
            name: 'EndDate',
            value: endDate
          },
          {
            name: 'isVisible',
            value: 1
          }
        ]
      });
    }

    static convertUnit = (currentQuantity, oldUnitId, newUnitId) => Api.post('_General_UnitCnvrsns', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'CumtQty',
          value: currentQuantity
        },
        {
          name: 'StartingUnitId',
          value: oldUnitId
        },
        {
          name: 'EndingUnitId',
          value: newUnitId
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })
}
